export default __webpack_public_path__ + "static/media/kokoro-3.f941a0e4.png";